// Importer tab (BUILD_SPEC.md §5.9, §2.13; plan.md G26): the Unleashed CSV
// importer wizard (upload/paste → kind + mapping → validate → commit) plus the
// job history register.
import { Divider, Stack } from '@mantine/core';
import { ImportJobHistory } from './ImportJobHistory';
import { ImportJobWizard } from './ImportJobWizard';

export function ImporterPanel() {
  return (
    <Stack gap="xl">
      <ImportJobWizard />
      <Divider />
      <ImportJobHistory />
    </Stack>
  );
}
